// extracted by mini-css-extract-plugin
module.exports = {"textAreaWrapper":"qMZBMPD7QRhxjgXoWaPzO","placeholder":"_1TSMWwcXdDpKa1bVJED3kJ","notEmpty":"_2KaVIjCdaHcbTgt9hBF-","error":"_3VR_PIzUuR8RwxIA31B87d"};